import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStandTransformationHistoryDetailsInputDto, StandTransformationHistoryDetailCreateDto, StandTransformationHistoryDetailDto, StandTransformationHistoryDetailExcelDownloadDto, StandTransformationHistoryDetailUpdateDto } from '../dtos/stand-transformation-history-detail/models';

@Injectable({
  providedIn: 'root',
})
export class StandTransformationHistoryDetailService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: StandTransformationHistoryDetailCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDetailDto>({
      method: 'POST',
      url: '/api/geographic/standTransformationHistoryDetails',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/standTransformationHistoryDetails/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/standTransformationHistoryDetails',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDetailDto>({
      method: 'GET',
      url: `/api/geographic/standTransformationHistoryDetails/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/standTransformationHistoryDetails/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStandTransformationHistoryDetailsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandTransformationHistoryDetailDto>>({
      method: 'GET',
      url: '/api/geographic/standTransformationHistoryDetails',
      params: { standTransformationHistoryId: input.standTransformationHistoryId, standTransformationHistoryName: input.standTransformationHistoryName, rotationId: input.rotationId, standLocationId: input.standLocationId, rotationName: input.rotationName, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, areaPercentage: input.areaPercentage, areaPercentageFrom: input.areaPercentageFrom, areaPercentageTo: input.areaPercentageTo, isFinal: input.isFinal, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StandTransformationHistoryDetailExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/standTransformationHistoryDetails/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, standTransformationHistoryId: input.standTransformationHistoryId, standTransformationHistoryName: input.standTransformationHistoryName, rotationId: input.rotationId, standLocationId: input.standLocationId, rotationName: input.rotationName, area: input.area, areaFrom: input.areaFrom, areaTo: input.areaTo, areaPercentage: input.areaPercentage, areaPercentageFrom: input.areaPercentageFrom, areaPercentageTo: input.areaPercentageTo, isFinal: input.isFinal, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDetailDto[]>({
      method: 'GET',
      url: '/api/geographic/standTransformationHistoryDetails/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StandTransformationHistoryDetailUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandTransformationHistoryDetailDto>({
      method: 'PUT',
      url: `/api/geographic/standTransformationHistoryDetails/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}